import OneSignal from "react-onesignal";

export async function InitOneSignal() {
  OneSignal.init({
    appId: "be58fbf1-e9eb-489b-a5fe-156bef10fe5b",
  }).then(() => {
    console.log("OneSignal SDK initialized");
  });
}
